import { CustomStorageProvider } from './../custom-storage/custom-storage';
import { Injectable } from '@angular/core';
import { Constants } from '../../util/Constants';
import { RestService } from '../../services/restService';
import { Util } from '../../util/Util';
import { Platform } from 'ionic-angular';
import { AppVersion } from '@ionic-native/app-version';

/*
  Generated class for the UserManagerProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class UserManagerProvider {

  constructor(private customStorageService: CustomStorageProvider, private restService: RestService, private platform: Platform,
    private appVersion: AppVersion) {
  }

  public isAdmin() {
    let userId = this.customStorageService.get(Constants.STORAGE_KEY_USER_ID);
    return userId == undefined ? false : userId < 0;
  }

  public isGuest() {
    let role = this.customStorageService.get(Constants.STORAGE_KEY_ROLE);
    return role == Constants.ROLE_GUEST;
  }

  public isUser() {
    let role = this.customStorageService.get(Constants.STORAGE_KEY_ROLE);
    return role == Constants.ROLE_USER;
  }

  public getLoginUserId():number {
    return this.customStorageService.get<number>(Constants.STORAGE_KEY_USER_ID);
  }

  public isShow5thHorse(): boolean {
    const userID = Number(this.getLoginUserId());
    // List if user to show 5th horse
    const allowedUserIds = [117576, 303293, 172975, 114685, 116799, 117276];
    return allowedUserIds.indexOf(userID) !== -1;
  }

  public getLoginUserNickname():string {
    return this.customStorageService.get<string>(Constants.STORAGE_KEY_NICKNAME);
  }

  public getLang(): string {
    return this.customStorageService.get<string>(Constants.STORAGE_KEY_LANG);
  }

  public isLoggedIn(): boolean {
    let savedWebSecret = this.customStorageService.get<string>(Constants.STORAGE_KEY_WEB_SECRET);
    return savedWebSecret != null && savedWebSecret != "";
  }

  public logout() {
    let role = this.customStorageService.get(Constants.STORAGE_KEY_ROLE);
		let rememberMe = this.customStorageService.get(Constants.STORAGE_KEY_REMEMBER_ME);

		// Clear Local Storage Key
		if (role == Constants.ROLE_GUEST) {
			this.customStorageService.remove(Constants.STORAGE_KEY_WEB_SOCKET_URL);
      // this.customStorageService.remove(Constants.STORAGE_KEY_FB_WEB_SOCKET_URL);
			this.customStorageService.remove(Constants.STORAGE_KEY_USER_ID);
			this.customStorageService.remove(Constants.STORAGE_KEY_WEB_SECRET);
			this.customStorageService.remove(Constants.STORAGE_KEY_REFERRAL_CODE);
			this.customStorageService.remove(Constants.STORAGE_KEY_FIRST_LAUNCH_FLAG);
			this.customStorageService.remove(Constants.STORAGE_KEY_ROLE);
			this.customStorageService.remove(Constants.STORAGE_KEY_NICKNAME);
			this.customStorageService.remove(Constants.STORAGE_KEY_SKIP_HOME_SCREEN_PROMPT);
      this.customStorageService.remove(Constants.STORAGE_KEY_RACE_CARDS);
      this.customStorageService.remove(Constants.STORAGE_KEY_RACE_CARDS_LAST_MODIFIED);
      this.customStorageService.remove(Constants.STORAGE_KEY_UNREAD_NEWS_COUNT);
      this.customStorageService.remove(Constants.STORAGE_KEY_FB_TIPS_PACKAGE_SELECTED_MATCH_DAY);
      this.customStorageService.remove(Constants.STORAGE_KEY_LIST_FB_TIPS_FILTER);
      this.customStorageService.remove(Constants.STORAGE_KEY_LIST_FB_TIPS_PACKAGE_FILTER);
      this.customStorageService.remove(Constants.STORAGE_KEY_LIST_TIPS_PACKAGE_FILTER);
      this.customStorageService.remove(Constants.STORAGE_KEY_LIST_IN_RACE_TIPS_FILTER);
		} else {
			this.customStorageService.remove(Constants.STORAGE_KEY_WEB_SOCKET_URL);
			this.customStorageService.remove(Constants.STORAGE_KEY_USER_ID);
			this.customStorageService.remove(Constants.STORAGE_KEY_WEB_SECRET);
			this.customStorageService.remove(Constants.STORAGE_KEY_REFERRAL_CODE);
			this.customStorageService.remove(Constants.STORAGE_KEY_FIRST_LAUNCH_FLAG);
			this.customStorageService.remove(Constants.STORAGE_KEY_ROLE);
			this.customStorageService.remove(Constants.STORAGE_KEY_NICKNAME);
			this.customStorageService.remove(Constants.STORAGE_KEY_SKIP_HOME_SCREEN_PROMPT);
      this.customStorageService.remove(Constants.STORAGE_KEY_RACE_CARDS);
      this.customStorageService.remove(Constants.STORAGE_KEY_RACE_CARDS_LAST_MODIFIED);
      this.customStorageService.remove(Constants.STORAGE_KEY_UNREAD_NEWS_COUNT);
      this.customStorageService.remove(Constants.STORAGE_KEY_FB_TIPS_PACKAGE_SELECTED_MATCH_DAY);
      this.customStorageService.remove(Constants.STORAGE_KEY_LIST_FB_TIPS_FILTER);
      this.customStorageService.remove(Constants.STORAGE_KEY_LIST_FB_TIPS_PACKAGE_FILTER);
      this.customStorageService.remove(Constants.STORAGE_KEY_LIST_TIPS_PACKAGE_FILTER);
      this.customStorageService.remove(Constants.STORAGE_KEY_LIST_IN_RACE_TIPS_FILTER);
			if (!rememberMe) {
				this.customStorageService.remove(Constants.STORAGE_KEY_PHONELOGIN_PHONENUMBER);
				this.customStorageService.remove(Constants.STORAGE_KEY_PHONELOGIN_PASSWORD);
			}
		}
  }

  public setShowShopMenu(): void {
    let showShopMenu:boolean = false;
    this.restService.checkVersion().then(version => {
      let deviceType;
      if (Util.isApp(this.platform)) {
        if (this.platform.is("ios")) {
          deviceType = "ios";
        } else if (this.platform.is("android")) {
          deviceType = "android";
        }
      } else {
        deviceType = "web";
      }
      let serverVersion = version[deviceType];
      Util.getClientVersion(this.platform, this.appVersion).then(clientVersion => {
        if (!Util.isApp(this.platform)) {
          showShopMenu = true;
        } else {
          let upgradeStatus = Util.getUpgradeStatus(serverVersion, clientVersion);
          if (upgradeStatus == "pending") { // app not released
            showShopMenu = false;
          } else {
            showShopMenu = true;
          }
        }
        this.customStorageService.set(Constants.STORAGE_KEY_SHOW_SHOP_MENU, showShopMenu);
      })
    }).catch(err => {
      console.log(err);
    })
  }

  isShowShopMenu(): boolean {
    return this.customStorageService.get<boolean>(Constants.STORAGE_KEY_SHOW_SHOP_MENU);
  }
}



// WEBPACK FOOTER //
// ./src/providers/user-manager/user-manager.ts